import React, { useState } from 'react'
import { Button } from '@paypalcorp/pp-react'

const FADE_DURATION_MILLISECONDS = 2500

interface Props {
  className: string
  isVisible?: boolean
  isMobile?: boolean
  buttonText: string
  isCheckButton?: boolean
  clipboardText?: string
  onClick?: () => void
}

const OfferCardButton = ({
  className,
  isVisible,
  isMobile,
  buttonText,
  isCheckButton,
  clipboardText = '',
  onClick
}: Props) => {
  const [state, setstate] = useState<'initial' | 'success'>('initial')
  if (!isVisible) {
    return null
  }

  const handleState = (code: string) => {
    navigator.clipboard.writeText(code)
    setstate('success')
    setTimeout(() => setstate('initial'), FADE_DURATION_MILLISECONDS)
  }

  const handleCodeClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent> &
      React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    event.stopPropagation()
    event.preventDefault()
    if (onClick) onClick()
    handleState(clipboardText)
  }

  const handleDealClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent> &
      React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    event.stopPropagation()
    event.preventDefault()
    if (onClick) onClick()
  }

  const handleClick = isCheckButton ? handleCodeClick : handleDealClick

  return (
    <div className={className}>
      <Button
        data-cy={className}
        theme="v2"
        secondary
        size={isMobile ? 'sm' : 'lg'}
        className="offer-card--v2__button-width"
        onClick={handleClick}
        screenReaderText={buttonText}
        btnState={state}
      >
        {buttonText}
      </Button>
    </div>
  )
}
export default OfferCardButton
